import CryptoJS from "crypto-js";
export async function decryptMessage(encryptedData, secretkey, ivValue) {
  const key = CryptoJS.enc.Utf8.parse(secretkey);

  const iv = CryptoJS.enc.Utf8.parse(ivValue.padEnd(16, "0"));
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
}
